module.exports = __webpack_public_path__ + "static/vegas-bad5cb8925f73d61cd60f83e5539ca37.jpg";